import { render, staticRenderFns } from "./LocationListItem.vue?vue&type=template&id=671b4f0a"
import script from "./LocationListItem.vue?vue&type=script&lang=js"
export * from "./LocationListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports